<template>
    <v-dialog v-model="dialog" max-width="300px" persistent>
        <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on" style="color: #00A998">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="30" rx="4" fill="#C3F7E8"/>
                    <path d="M13 21H17V19H13V21ZM6 9V11H24V9H6ZM9 16H21V14H9V16Z" fill="#00A998"/>
                </svg>
                Filter
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6L8 10L4 6" stroke="#00A998" stroke-opacity="0.9" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </p>
        </template>
        <v-card class="pa-10">
            <div class="d-flex justify-space-between align-center mb-5">
                <v-img src="~@/assets/svg/CloseModalIcon.svg" style="cursor: pointer" max-width="18px" max-height="18px"
                       @click="dialog = false"/>
                <span class="clear-filter" @click="clearChecks">CLEAR FILTER</span>
            </div>
            <div class="mb-4">
                <template v-for="label in optionsToDisplay">
                    <small v-for="option in label.options" :key="option">{{option}}
                        <span @click="[removeOption({label: label.label, option: option,})]">&times;</span>
                    </small>
                </template>
            </div>
            <div v-for="label in filterDataLabels" :key="label">
                <FilterInnerModal :filter-data="filterData[label]"/>
            </div>
            <v-btn
                    elevation="false"
                    block
                    class="mt-5"
                    @click="filterApplicantsAndCloseModal"
            >Apply
            </v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
    import {filterData} from "../../../../../../assets/js/filterData";
    import {mapActions, mapGetters} from 'vuex'
    import FilterInnerModal from "./FilterInnerModal";

    export default {
        name: "FilterModal",
        components: {FilterInnerModal},
        data: () => ({
            dialog: false,
            filterData: {},
            filterDataLabels: [],
        }),
        created() {
            this.filterData = filterData()
            this.filterDataLabels = Object.keys(this.filterData)
        },
        methods: {
            ...mapActions(['filterApplicants', 'clearCurrentChecks', 'setFilterConditionsWithOption', 'removeFromCurrentChecks']),
            filterApplicantsAndCloseModal() {
                this.filterApplicants()
                this.dialog = false
            },
            clearChecks() {
                this.currentChecks.map(checked => {
                    this.filterData[checked].selected = false
                    this.setFilterConditionsWithOption({label: checked, action: 'clear'})
                    this.clearCurrentChecks()
                })
            },
            removeOption(payload) {
                this.setFilterConditionsWithOption({label: payload.label, options: payload.option, action: 'remove'})
                this.filterData[payload.label].selected = false
                if (this.filterConditions[payload.label].option.length === 0)
                    this.removeFromCurrentChecks(payload.label)
            }
        },
        computed: {
            ...mapGetters(['currentChecks', 'filterConditions']),
            optionsToDisplay() {
                const optionsToDisplay = []
                Object.keys(this.filterConditions)
                    .map((filterCondition, i) => optionsToDisplay[i] = {
                        label: filterCondition,
                        options: this.filterConditions[filterCondition].option
                    })
                return optionsToDisplay
            }
        }
    }
</script>

<style scoped>
    .v-dialog {
        height: 600px;
    }

    .close-btn, .filter-btn {
        border-width: 1px;
        border-style: solid;
        padding: 8px 12px;
        border-radius: 6px;
        color: #FFF;
        /*margin-bottom: 20px;*/
        font-weight: 300 !important;
    }


    .clear-filter {
        cursor: pointer;
        padding: 6px;
        border-radius: 5px;
        transition: all .3s ease-in-out;
        font-size: 12px;
        font-weight: bolder;
    }

    .clear-filter:hover {
        background: #F6F6F6;
    }

    .v-btn {
        background-color: #FF2E2E !important;
        color: #FFF;
        text-transform: uppercase;
    }

    small {
        background: #FFF2C7;
        padding: 5px;
        margin-right: 3px;
        margin-bottom: 3px;
        margin-top: 3px;
        color: #00A998;
        border-radius: 3px;
        font-weight: bold;
        white-space: nowrap;
    }

    small > span {
        color: #960C0C;
        font-size: 16px;
        margin-left: 2px;
        cursor: pointer;
        font-weight: normal;
    }

    /*small > span:hover {*/
    /*    background: #FF2E2E;*/
    /*    opacity: .2;*/
    /*    border-radius: 50%;*/
    /*}*/
</style>